"use client";

import React from "react";
import { isMSWProgram } from "@/shared/lib/programConstants";
import Link from "next/link";

const MS_FOOTER_DOCS = {
  privacyPolicy: {
    url: "https://www.morganstanley.com/disclosures/us-privacy-policy-and-notice",
  },
} as const;

const asset = (file: string) => `/assets/give-docs/${file}`;

interface MSProgramFooterProps {
  variant?: "default" | "compact";
}

export default function MSProgramFooter({
  variant = "default",
}: MSProgramFooterProps) {
  // Only render for MS program and specific roles
  if (!isMSWProgram()) return null;

  const year = new Date().getFullYear();
  const isCompact = variant === "compact";

  return (
    <footer className={`w-full mt-auto ${isCompact ? "py-3 mt-4" : "py-6"}`}>
      <div
        className={`text-center text-[#667085] ${isCompact ? "text-[11px]" : "text-[13px]"}`}
      >
        <p className={isCompact ? "mb-0.5" : "mb-1"}>
          © {year} Powered by TIFIN Give. All Rights Reserved.
        </p>
        <p className={isCompact ? "mb-0.5" : "mb-1"}>
          Morgan Stanley at Work&apos;s Charitable Giving platform is powered by
          TIFIN Give&apos;s technology.
        </p>
        <p className={isCompact ? "mb-1" : "mb-2"}>
          Product and Support services are provided by TIFIN Give under Morgan
          Stanley&apos;s name.
        </p>

        <div
          className={`flex flex-col items-center ${isCompact ? "gap-1" : "gap-2"}`}
        >
          <Link
            href={MS_FOOTER_DOCS.privacyPolicy.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand-primary hover:underline"
          >
            U.S. Privacy Policy & Notice | Morgan Stanley
          </Link>
          <Link
            href={asset("MS_AddtionalDisclosure_Give.pdf")}
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand-primary hover:underline"
          >
            Additional Disclosure | Morgan Stanley
          </Link>
        </div>
      </div>
    </footer>
  );
}
